import { render } from "./YelloPageCategory.vue?vue&type=template&id=0e73dc32"
import script from "./YelloPageCategory.vue?vue&type=script&lang=js"
export * from "./YelloPageCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__